<div class="eyrus-side-menu" id="side-menu">
  <div class="side-menu-header">
    <div class="close-menu hide-md hide-lg" id="close-menu" (click)="close()">
      <i class="ae ae-times"></i>
    </div>

    <div class="logo-info hide-xs hide-sm">
      <div class="gs w-100 align-items-center">
        <div class="custom-lay">
          <i class="ae ae-menu" (click)="toggleSidebarCollapsed()"></i>
        </div>
        <div class="lay logo-lay align-center">
          <img src="assets/img/logo.png" alt="">
        </div>
      </div>  
    </div>

    <div class="user-info hide-md hide-lg">
      <!-- <div class="avatar">
        <img src="https://api.adorable.io/avatars/285/abott@adorable.png">
      </div> -->
      <div class="about">
        <p class="name" id="user-name">
          {{ currentUser?.user?.firstName || '' }} {{ currentUser?.user?.lastName || '' }}
        </p>
        <span class="company" (click)="goToProfileEdit()">
          {{ "common.editProfile" | translate }}
        </span>

      </div>
    </div>
  </div>

  <div class="side-menu-header hide-lg hide-md" >
    <div class="company-info">
      <!-- <div class="about">
        <p class="name" id="user-company">
          {{ currentUser?.company?.companyName || '' }}
        </p>
      </div> -->

      <ng-container *ngFor="let item of currentUser?.accounts;">
        <div class="menu-items-holder inner">
          <a class="item-row"
            [ngClass]="{
              'active-link': sameId(item?.accountId)
            }"
            (click)="switchAccount(item)"
            routerLinkActive="active-link">
            <i class="main-icon ae ae-setting-icon"></i>
            <p> {{ item.accountName }}</p>
          </a>
        </div>
      </ng-container>
    </div>
  </div>


  <div class="menu-items-holder">
    <div *ngFor="let item of menuItems">
      <ng-container *accountHasPermission="item?.permissions">
        <a class="item-row" *ngIf="item.display"
          (click)="doMenuAction(item); "
          routerLinkActive="active-link"
          [ngClass]="{ 
            'disabled-item': item.disabled, 
            'active-link': getActivePath(item?.shouldBeActive) 
          }">
          <i class="main-icon" [ngClass]="item.icon"></i>
          <p> {{ item.label | translate }}</p>
        </a>
      </ng-container>
    </div>
  </div>

  <div class="menu-items-holder eyrus-axon-holder">
    <div class="divider"></div>
    <div>
      <a class="item-row"
        href="{{ getApexUrl() }}"
        target="_blank">
        <i class="main-icon">
          <img src="assets/img/eyrus-logo.svg" class="eyrus-axon-logo">
        </i>
        <p> 
          {{ "common.returnToAxon" | translate }}
        </p>
      </a>
    </div>
  </div>
</div>